/**
 * categorizer.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { ClassProvider, Injectable } from "@angular/core";

import { MessagingService } from "../../../server/messaging.service";
import { jsonify } from "../../../support/utilities/functions";

import { AlgorithmStep, IntakeStep } from "../../structure/";
import { StepTransformer, TransformerEffects }
    from "./step-transformer";

/**
 * The {@link Categorizer} stage of the {@link AlgorithmStep} pipeline analyzes
 * the classifications present on each step and attempts to (crudely) identify
 * a *unique* category to assign to it.
 */
@Injectable()
export class Categorizer extends StepTransformer
{
    // Where this class should be sorted in the transformer list
    public order : number = 50;

    public matchesType (type : any) : boolean
    {
        return type === IntakeStep;
    }

    // CURRENTLY UNUSED - A record of the available categories
    public categories : string[] = [];

    /**
     * Create the {@link Categorizer}
     */
    public constructor (protected messaging : MessagingService)
    {
        super();
        // Eventually we'll need to listen for info about what categories are
        // "available" and how to prioritize them.

        // this.messaging.receive(AlgorithmInfoMessage).subscribe(
        //     (msg : AlgorithmInfoMessage) => {
        //         this.categories = msg.categories;
        //     });
    }

    /**
     * Extract the category from an {@link AlgorithmStep}
     */
    public create (step : IntakeStep) : TransformerEffects
    {
        // ignore hint categories
        const nonHint : string[] = step.classifications.filter(
            (classification : string) => !classification.startsWith("hint"));
        if (nonHint.length > 1)
        {
            // throw away the first category, which is likely to be an algorithm
            // name category under current language standards
            step.hints.category = nonHint[1];
        }
        return {};
    }

    public apply () : TransformerEffects
    {
        return {};
    }
}

/**
 * Create a provider for easy import that uses the {@link StepTransformer} class
 * as a multi-provider injection token.
 */
export const CATEGORIZER : ClassProvider = {
    provide: StepTransformer,
    useClass: Categorizer,
    multi: true
};



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/management/pipeline/categorizer.ts